let MATRIX_INTEGRATION_ID = {
  type: 'Matrix',
  key: 'orgId',
  value: ''
};

export default MATRIX_INTEGRATION_ID;



// WEBPACK FOOTER //
// ./app/models/matrixIntegration.js